import styled from 'styled-components';

export const LoaderWrapper = styled.div`
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	z-index: 1100;
	display: flex;
	justify-content: center;
	align-items: center;
`;
